<script>
export default {
  components: {},
  data() {
    return {
      backgroundImage: require(`@/assets/images/background.jpg`),
    };
  },
};
</script>

<template>
  <div>
    <div
      class="account-pages d-flex flex-column justify-content-center"
      style="height: 100vh; width: 100vw; background-size: cover"
      :style="{ 'background-image': `url(${backgroundImage})` }"
    >
      <div class="container">
        <slot />
      </div>
    </div>
  </div>
</template>
